var anchorElement = $('<a>', {
    href: 'https://trade.diamondnailsupplies.com.au/',  // Set the href attribute as needed
    text: 'Trade Portal',  // Set the anchor text as needed
    class: 'trade-link'  // Replace 'your-class-name' with the desired class name
});

$('.header--localization').append(anchorElement);
